import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './Tab.module.less';

const Tab = ({
  children,
  href,
  selected = false,
  disabled = false,
  inDropdown = false,
  onClick = function() {},
}) => {
  return (
    <a
      href={href}
      className={clsx(
        styles.tab,
        inDropdown && styles.dropdown,
        selected && styles.selected,
        disabled && styles.disabled
      )}
      onClick={e => onClick(e, href)}
    >
      <span>{children}</span>
    </a>
  );
};

Tab.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  inDropdown: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Tab;
